import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Widget, WidgetProps } from '../..';
import { LeaderboardItem } from './leaderboard-item';
import { LeaderboardMemberDto } from '@/store/services/MidleNestApi.service';

interface Props extends WidgetProps {
  title?: string;
  users?: LeaderboardMemberDto[] | null;
  clans?: LeaderboardMemberDto[] | null;
  link?: string;
  defaultTab?: 'players' | 'clans';
  hideActions?: boolean;
}

export default function LeaderboardWidget({
  title,
  users,
  clans,
  defaultTab = 'players',
  hideActions = false,
  ...props
}: Props) {
  const [tab, setTab] = React.useState<'players' | 'clans'>(defaultTab);

  const { t } = useTranslation();

  const _title = {
    players: t('Leaderboard (Players)'),
    clans: t('Leaderboard (Clans)'),
  }[tab];

  return (
    <Widget
      className='relative flex-1'
      title={title || _title}
      {...props}
      actions={
        !hideActions && (
          <div className='w-full flex'>
            <button
              onClick={() => setTab('players')}
              className={classNames(
                'px-6 py-2 text-sm leading-5 font-medium text-blue-500 rounded-lg',
                tab === 'players'
                  ? 'bg-blue-50 dark:bg-[#FFDA68]/30 dark:text-[#151515]'
                  : 'hover:opacity-100 dark:text-[#FFDA68]',
              )}
            >
              {t('Players')}
            </button>
            <button
              onClick={() => setTab('clans')}
              className={classNames(
                'px-6 py-2 text-sm leading-5 font-medium text-blue-500 rounded-lg',
                tab === 'clans'
                  ? 'bg-blue-50 dark:bg-[#FFDA68]/30 dark:text-[#151515]'
                  : 'hover:opacity-100 dark:text-[#FFDA68]',
              )}
            >
              {t('Clans')}
            </button>
            {/*<Form>*/}
            {/*  <Select*/}
            {/*    className='w-24 h-9 p-0 pl-3 text-sm leading-5 font-normal text-gray-800 ml-4'*/}
            {/*    name='leaderboard-time'*/}
            {/*    options={[{ children: t('All Time') }]}*/}
            {/*  />*/}
            {/*</Form>*/}
          </div>
        )
      }
    >
      <div className='w-full dark:text-white'>
        <table className='w-full text-xs md:text-sm'>
          <thead className='h-12 font-medium'>
            {tab === 'players' && (
              <tr className='text-center'>
                <td></td>
                <td className='text-left'>{t('Username')}</td>
                <td className='hidden sm:table-cell whitespace-nowrap truncate'>
                  {t('Avg.Point Per Day')}
                </td>
                <td className='hidden sm:table-cell text-center'>{t('Clan')}</td>
                <td>{t('Total Points')}</td>
              </tr>
            )}
            {tab === 'clans' && (
              <tr className='text-center'>
                <td></td>
                <td className='text-left'>{t('Name')}</td>
                <td className='hidden sm:table-cell text-center'>{t('Avg. Points per Day')}</td>
                <td className='hidden sm:table-cell'>{t('Members')}</td>
                <td>{t('Total Points')}</td>
              </tr>
            )}
          </thead>
          <tbody className='text-sm divide-y divide-gray-100 dark:divide-gray-700'>
            {tab === 'players' &&
              users?.map((i, k) => <LeaderboardItem.User key={'users_lb_' + k} {...i} />)}

            {tab === 'clans' &&
              clans?.map((i, k) => <LeaderboardItem.Clan key={'clans_lb_' + k} {...i} />)}
          </tbody>
        </table>
      </div>

      <footer className='mt-2 md:mt-4 flex items-center justify-end'>
        <Link
          to={`/leaderboards/${tab}`}
          className='text-blue-500 dark:text-[#FFDA68] font-medium flex items-center text-sm'
        >
          {t('View Top') + (tab === 'players' ? ' 100' : ' 10')}
          <i className='icon-right-open-big mt-0.5 ml-1' />
        </Link>
      </footer>
    </Widget>
  );
}
